import React, { useState } from 'react';
import styles from './FAQ.module.css';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'When can I purchase the LifeInPXL frame?',
      answer: "We'll launch this project on Feb 2026. We're finalizing production and expect to ship the first batch in January. Leave your email below to get notified the moment we launch, so you can secure your Early Bird price and be among the first to receive it."
    },
    {
      question: 'How do I get my photos from my phone to the LifeInPXL frame?',
      answer: "It's effortless! Download the free LifeInPXL app, and follow the in-app steps to sync your phone's photo library. You can select multiple photos, specific albums, or favorites. It's a one-time setup for a continuous stream of memories."
    },
    {
      question: 'What makes this different from a tablet or a regular digital photo frame?',
      answer: "Great question! Unlike a tablet, our E Ink screen is glare-free, looks just like real paper, and is incredibly easy on the eyes. Compared to traditional digital frames, LifeInPXL is ultra-thin, has a massive multi-month battery life, and its unique magnetic design lets you place it anywhere—especially on your fridge, turning it into a central part of your home."
    },
    {
      question: 'How long does the battery last, and how often do I need to charge it?',
      answer: "Thanks to the ultra-low-power E Ink screen, the battery lasts for more than one year on a single charge. We've engineered it for a truly 'set it and forget it' experience. You'll only need to charge it 1 times a year for normal use."
    },
    {
      question: 'I have other questions.',
      answer: 'Reach us by email at service@lifeinpxl.com'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className={styles["faq"]}>
      <div className={styles["faq-container"]}>
        <h2 className={styles["faq-title"]}>Frequently Asked Questions</h2>
        <div className={styles["faq-list"]}>
          {faqs.map((faq, index) => (
            <div key={index} className={styles["faq-item"]}>
              <button
                className={styles["faq-question"]}
                onClick={() => toggleFAQ(index)}
              >
                <span>{faq.question}</span>
                <span className={`${styles["faq-icon"]} ${openIndex === index ? styles["faq-icon-open"] : ""}`}>
                  +
                </span>
              </button>
              {openIndex === index && (
                <div className={styles["faq-answer"]}>
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;

